import {createAction} from '@reduxjs/toolkit'

import type {PaymentMethodConfiguration} from 'services/payment/paymentMethods'

export type PayrailsStatus = 'idle' | 'ready' | 'failed'

export const setPspInitialized = createAction<boolean>(
  'common/setPspInitialized'
)
export const setPayrailsStatus = createAction<PayrailsStatus>(
  'common/setPayrailsStatus'
)
export const setEnabledWallets = createAction<PaymentMethodConfiguration[]>(
  'common/setEnabledWallets'
)

export type ActionType =
  | ReturnType<typeof setPspInitialized>
  | ReturnType<typeof setPayrailsStatus>
  | ReturnType<typeof setEnabledWallets>
